import { useCreateJumpUrl } from "./use-create-jump-url";
import { useCreateTargetUrl } from "./use-create-target-url";

/**
 * Get the functions to convert URN into proxy call to redirect users.
 * `TargetUrl` should be used when only the redirection is needed.
 * `JumpUrl` should be used when the user should go throught the login app to obtain a new session
 *
 * @returns {{createTargetUrl: targetUrl, createJumpUrl: jumpUrl}} Object contains two synchronous function to convert
 *  the URN into a proxy url to redirect the user.
 */
export const useProxy = () => {
  const targetUrl = useCreateTargetUrl();
  const jumpUrl = useCreateJumpUrl();

  return {
    createTargetUrl: targetUrl,
    createJumpUrl: jumpUrl
  };
};
